module.exports = __webpack_public_path__ + "static/img/exploit6.5012fbf8.png";